import { publicCreateRetractationReturnRequest } from "@babackapp/private-api-client/client/use-public-create-retractation-return-request";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ReturnDraft } from "../types";

export function useCreateRetractationReturnRequest(orderId: string, shopSlug: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (draft: ReturnDraft) =>
      publicCreateRetractationReturnRequest({
        orderId: draft.orderId,
        shopId: draft.shopId,
        lineItems: draft.lineItems.map((li) => ({
          lineItemId: li.lineItemId,
          quantity: li.quantity,
        })),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        shippingAddress: draft.address! as any,
        notifications: { consumerEnabled: true },
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [
          "get",
          "/public/return-request/search",
          { params: { query: { orderId, shopSlug } } },
        ],
        refetchType: "all",
      }),
  });
}
